import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { AngularUiModule } from '@univacity/angular/ui';
import { Tour } from '@univacity/shared/types';

@Component({
  selector: 'un-tour-header-pricing',
  imports: [FontAwesomeModule, AngularUiModule],
  templateUrl: './tour-header-pricing.component.html',
  styleUrls: ['./tour-header-pricing.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourHeaderPricingComponent {
  @Input() tour: Tour;
  faCheck = faCheck;

  get pricing() {
    return this.tour.onSales && this.tour.sales
      ? this.tour?.sales
      : this.tour.pricing;
  }
}
